export enum EAppointmentStatus {
    Pending = 1,
    Approved = 2,
    Doing = 3,
    Done = 4,
    Cancelled = 5 
}